import React, { Component, MouseEvent, ReactNode } from 'react';
import CaseDetailHeaderComponent from './detail/CaseDetailHeaderComponent';
import CaseDetailIndicatorPanelComponent from './detail/CaseDetailIndicatorPanelComponent';
import CaseDetailSummaryPanelComponent from './detail/CaseDetailSummaryPanelComponent';
import CaseDetailVariablePanelComponent from './detail/CaseDetailVariablePanelComponent';
import Breadcrumb from '../../Breadcrumb';
import CaseTransactionsActivityComponent from './CaseTransactionsActivityComponent';
import { query, repository, subscribe } from '@trlogic/client-js';
import CollectionNames from '../../../constant/CollectionNames';
import {
  AlarmCloseCode,
  CaseChartPanel,
  CaseFieldPanel,
  CaseGraphField,
  CasePanelType,
  CaseSettings,
  CloseCaseBulkActionOperation,
} from '../../../domain/case/CaseDomains';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { RootState, store } from '../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import CaseService from '../../../service/CaseService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import CustomLoading from '../../custom/CustomLoading';
import NavigationUtil from '../../../util/NavigationUtil';
import _ from 'lodash';
import { TransactionData, TransactionReason } from '../../../domain/stream/transaction/TransactionDomains';
import CaseAttachmentContainerComponent from './attachment/CaseAttachmentContainerComponent';
import { ComponentState, enterComponent, leaveComponent } from '../../../redux/actions/ComponentActions';
import ComponentName from '../../../constant/ComponentName';
import ItemToolsMenu from '../../ItemToolsMenu';
import JobService from '../../../service/JobService';
import CaseActionUtil from '../../../util/CaseActionUtil';
import { TransactionDataExportJob } from '../../../domain/job/JobDomain';
import { buildExportColumnPreferences } from '../../../util/ColumnExportUtil';
import moment from 'moment';
import FolderService from '../../../service/FolderService';
import { changePageFilter, clearPage } from '../../../redux/actions/PageActions';
import { PageState } from '../../../redux/reducers/PageReducer';
import FilterUtil from '../../../util/FilterUtil';
import { CustomFilter as FilterType, CustomFilterFields, CustomFilterLiteralSearch } from '../../../domain/ui/FilterDomains';
import { User, UserSystemAttributes, UserSystemTableAttributes } from '../../../domain/rbac/RbacDomains';
import RoleHelper from '../../../RoleHelper';
import CaseGraphComponent from '../../graph/CaseGraphComponent';
import ValueUtil from '../../../util/ValueUtil';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import Icon from '../../../icons/Icon';
import MessageUtil from '../../../util/MessageUtil';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';
import DataType from 'constant/DataType';
import LanguageUtil from '../../../util/LanguageUtil';
import { assigneeIdFromStoredValue } from '../../../util/CaseAssigneeUtil';
import { canEditCaseDomain, canUseCaseGo } from '../../../util/CasePermissionUtil';
import { canPerformBulkClose } from '../../../util/CaseBulkCloseUtil';
import CustomTabv3 from '../../custom/CustomTabv3';
import DomainConfigurationService from '../../../service/DomainConfigurationService';
import { CaseState } from '../../../redux/reducers/CaseReducer';
import { changeCaseColumns } from '../../../redux/actions/CaseActions';
import { setAttribute } from '../../../redux/actions/UserActions';
import CustomTabv2 from '../../custom/CustomTabv2';
import CaseAuditComponent from './CaseAuditComponent';
import CaseDetailChartPanelComponent from './detail/CaseDetailChartPanelComponent';
import TransactionApiUpdateDialog from './detail/TransactionApiUpdateDialog';
import { DefaultTransactionApiUpdateDetector, LocalCaseMutation, TransactionApiUpdateDetector } from './detail/TransactionApiUpdateDetector';
import TransactionPageUtil from '../../../pages/transaction/TransactionPageUtil';
import { ConfirmPopup } from 'primereact/confirmpopup';
import eq = query.eq;
import and = query.and;
import QueryBuilder = query.QueryBuilder;
import empty = query.empty;
import Filter = query.Filter;
import Order = query.Order;
import MatchFilter = query.MatchFilter;
import ConditionalFilter = query.ConditionalFilter;
import or = query.or;
import neq = query.neq;

class CaseDetailComponent extends Component<Props, State> {
  public state: State = new State();

  private readonly caseService: CaseService = ServiceContainer.getInstance().get(ServiceNames.CASE);
  private readonly caseSettingsService: DomainConfigurationService = ServiceContainer.getInstance().get(ServiceNames.DOMAIN_CONFIGURATION);
  private readonly jobService: JobService = ServiceContainer.getInstance().get(ServiceNames.JOB);
  private readonly repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private readonly transactionApiUpdateDetector: TransactionApiUpdateDetector = new DefaultTransactionApiUpdateDetector();
  private localCaseMutation: LocalCaseMutation | undefined;

  private alarmDomainSubscription: subscribe.Subscription | undefined;
  private transactionSubscription: subscribe.Subscription | undefined;
  private ruleSubscription: subscribe.Subscription | undefined;
  private logSubscription: subscribe.Subscription | undefined;

  private computation: subscribe.Computation | undefined;
  private transactionComputation: subscribe.Computation | undefined;

  private transactionIntervalId: any;
  private caseGoInFlight: boolean = false;
  private caseGoCompleted: boolean = false;

  public render(): ReactNode {
    const { currentTransaction, alarmDomain, scores, disabled, users, commentModalVisible, commentCount, apiUpdateNoticeVisible } = this.state;
    const { user } = this.props;

    if (currentTransaction == undefined || alarmDomain == undefined) {
      return <CustomLoading />;
    }

    return (
      <div className={'flex flex-col w-full gap-y-5 h-full'}>
        <Breadcrumb />
        <ConfirmPopup />
        <div className={'flex flex-col w-full h-full gap-y-5'}>
          <CaseDetailHeaderComponent
            transactionData={currentTransaction}
            alarmDomain={alarmDomain}
            nextCase={this.goNextCase}
            actionModalOpen={this.actionModalOpen}
            listModalOpen={this.listModalOpen}
            commentModalOpen={this.commentModalOpen}
            scores={scores}
            disabled={disabled}
            users={users}
            riskType={user.activeRiskType}
            commentCount={commentCount}
            onLocalCaseMutation={this.markLocalCaseMutation}
            onLocalCaseMutationFailed={this.clearLocalCaseMutation}
          />
          <div className={'flex flex-col w-full h-full'}>
            <CustomTabv2 tab={this.getTabs()} />
          </div>
          <CaseAttachmentContainerComponent
            visible={commentModalVisible}
            transaction={currentTransaction}
            domain={alarmDomain?.name}
            disabled={disabled}
            onClose={this.commentModalClose}
            setCommentCount={(count) => this.setState({ commentCount: count })}
          />
          <TransactionApiUpdateDialog visible={apiUpdateNoticeVisible} onRefresh={this.applyApiTransactionUpdate} />
        </div>
      </div>
    );
  }

  public componentDidMount = async () => {
    const params = this.getRouteParams();
    this.addInitialFilter(params.keyField, params.keyValue);
    await this.init();
  };

  private init = async () => {
    const {
      enterComponent,
      router: { location },
      user,
    } = this.props;
    const params = this.getRouteParams();
    const id = `${params.transaction}-${user.activeRiskType}-${params.index}`;
    enterComponent({ component: ComponentName.CASE, id, disablePathCalculation: true });
    await FolderService.calculateCase(location.pathname, params.domain!, params.index!);
    await this.loadAssignableUsers();
    await this.fetchCase();
    this.startTracker();
    this.startTransactionInterval();
  };

  public componentWillUnmount = async () => {
    const { leaveComponent, clearPage } = this.props;
    clearPage();
    leaveComponent();
    clearInterval(this.transactionIntervalId);
    await this.stopTracker();
  };

  private startTracker = async () => {
    const { router } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const domainName: string | null = previousSearchParams.get('domain');
    const caseIndex: string | null = previousSearchParams.get('index');
    const transaction: string | null = previousSearchParams.get('transaction');

    if (domainName == undefined || caseIndex == undefined || transaction == undefined) return;

    const caseSettings = await this.caseSettingsService.getByChannel(transaction);
    if (caseSettings == undefined) return;

    const alarmDomainQuery: query.Query = query.QueryBuilder.select().from(CollectionNames.CASE_SETTINGS).where(eq('name', domainName)).build();
    const transactionQuery: query.SelectQuery = query.QueryBuilder.select()
      .from(CollectionNames.TRANSACTIONS)
      .where(or(eq('id', transaction), ...caseSettings.additionalChannels.map((c) => eq('name', c.channel))))
      .build();
    const ruleQuery: query.SelectQuery = query.QueryBuilder.select()
      .from(CollectionNames.RULES)
      .where(eq('workflow.children.value.name', transaction))
      .select('name', 'description', 'workflow.children.value.name', 'riskType')
      .build();

    this.alarmDomainSubscription = subscribe.Formica.subscribe(CollectionNames.CASE_SETTINGS, alarmDomainQuery);
    this.transactionSubscription = subscribe.Formica.subscribe(CollectionNames.TRANSACTIONS, transactionQuery);
    this.ruleSubscription = subscribe.Formica.subscribe(CollectionNames.RULES, ruleQuery);
    this.computation = subscribe.Tracker.autorun(this.tracker, [
      this.alarmDomainSubscription,
      this.transactionSubscription,
      this.ruleSubscription,
    ]);
  };

  private stopTracker = async () => {
    await this.transactionSubscription?.stop();
    await this.alarmDomainSubscription?.stop();
    await this.transactionComputation?.stop();
    await this.ruleSubscription?.stop();
    await this.logSubscription?.stop();
    await this.computation?.stop();
  };

  private startTransactionInterval = async () => {
    await this.onTransactionInterval();
    this.transactionIntervalId = setInterval(this.onTransactionInterval, 2_000);
  };

  private restartTransactionInterval = () => {
    clearInterval(this.transactionIntervalId);
    this.startTransactionInterval();
  };

  private markLocalCaseMutation = (status: TransactionReason, code: string): void => {
    this.localCaseMutation = { status, code };
  };

  private clearLocalCaseMutation = (): void => {
    this.localCaseMutation = undefined;
  };

  private holdApiTransactionUpdate = (transaction: TransactionData): void => {
    const pending: TransactionData | undefined = this.state.pendingApiTransaction;
    const pendingRevision: string | undefined =
      pending == undefined ? undefined : this.transactionApiUpdateDetector.revision(pending, this.props.user.activeRiskType);
    const nextRevision: string = this.transactionApiUpdateDetector.revision(transaction, this.props.user.activeRiskType);
    if (this.state.apiUpdateNoticeVisible && pending != undefined && pending.id === transaction.id && pendingRevision === nextRevision) {
      return;
    }
    this.setState({
      apiUpdateNoticeVisible: true,
      pendingApiTransaction: transaction,
    });
  };

  private applyApiTransactionUpdate = (): void => {
    window.location.reload();
  };

  private onTransactionInterval = async () => {
    const { router, user } = this.props;
    const { scores } = this.state;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const caseIndex: string | null = previousSearchParams.get('index');
    const domain: string | null = previousSearchParams.get('domain');
    const transaction: string | null = previousSearchParams.get('transaction');
    const additionalOrDefaultTransaction: string | undefined | null = this.getAdditionalOrDefaultTransaction();
    if (domain == undefined || caseIndex == undefined || transaction == undefined || additionalOrDefaultTransaction == undefined) {
      return;
    }
    try {
      const casesQuery = this.getCaseSubscriptionQuery();
      const caseQuery: query.SelectQuery = query.QueryBuilder.select()
        .where(eq('id.keyword', caseIndex))
        .from(`risk_transaction_log_${NavigationUtil.getTenant()}_*`)
        .build();
      const currentTransaction = (await this.caseService.getPageData(transaction, caseQuery)).data[0];
      if (!currentTransaction) {
        clearInterval(this.transactionIntervalId);
        router.navigate('/404');
        return;
      }
      const transactionForState: TransactionData = currentTransaction;
      const _cases = await this.caseService.getPageData(additionalOrDefaultTransaction, casesQuery);
      if (this.state.currentTransaction == undefined && transactionForState != undefined) {
        this.subscribeToLogs(transactionForState);
      }
      const localTransaction: TransactionData | undefined = this.state.currentTransaction;
      const localStatus: TransactionReason | undefined = localTransaction?.result?.[user.activeRiskType]?.status;
      const remoteStatus: TransactionReason | undefined = currentTransaction?.result?.[user.activeRiskType]?.status;
      const remoteIsNewer: boolean = (currentTransaction?.updatedAt ?? 0) > (localTransaction?.updatedAt ?? 0);
      const skipStaleWaitingRefresh: boolean =
        localStatus === TransactionReason.IN_REVIEW && remoteStatus === TransactionReason.WAITING_FOR_REVIEW && !remoteIsNewer;
      const apiUpdateNotice: boolean = this.transactionApiUpdateDetector.shouldNotify(
        this.state.currentTransaction,
        transactionForState,
        user.activeRiskType,
        this.localCaseMutation,
      );
      if (this.transactionApiUpdateDetector.matchesLocalMutation(transactionForState, user.activeRiskType, this.localCaseMutation)) {
        this.localCaseMutation = undefined;
      }
      const holdApiUpdate: boolean = this.state.apiUpdateNoticeVisible || apiUpdateNotice;
      if (apiUpdateNotice) {
        this.holdApiTransactionUpdate(transactionForState);
      } else if (
        !holdApiUpdate &&
        !skipStaleWaitingRefresh &&
        (!_.isEqual(transactionForState, this.state.currentTransaction) ||
          (this.state.currentTransaction == undefined && transactionForState != undefined))
      ) {
        const activeRuleCount = transactionForState?.result?.[user.activeRiskType]?.rules?.length ?? 0;
        this.setState({ currentTransaction: transactionForState, activeRuleCount, transactionDataLoading: false }, this.getScores);
      }
      if (Object.keys(scores).length == 0) {
        this.getScores();
      }
      if (!_.isEqual(_cases.data, this.state.transactions)) {
        this.setState({ transactions: _cases.data, transactionDataLoading: false });
      }
      if (currentTransaction && this.state.alarmDomain && !holdApiUpdate) {
        this.checkActionButtonsDisabled(transactionForState);
      }
      await this.fetchCount();
      if (this.state.transactionDataLoading) {
        this.setState({ transactionDataLoading: false });
      }
    } catch (error) {
      console.error('Failed to refresh transaction detail', error);
      clearInterval(this.transactionIntervalId);
    }
  };

  private getCaseSubscriptionQuery = () => {
    const { currentPage, rows, filter, sort } = this.state;
    const transaction: string | undefined | null = this.getAdditionalOrDefaultTransaction();
    const caseQueryBuilder: query.SelectQueryBuilder = query.QueryBuilder.select()
      .skip((currentPage - 1) * rows)
      .limit(rows)
      .from(`risk_transaction_log_${NavigationUtil.getTenant()}_${transaction}_*`.toLowerCase())
      .where(filter)
      .orderBy(...TransactionPageUtil.getSort(sort));

    caseQueryBuilder.where(and(eq('name.keyword', transaction), caseQueryBuilder.build().filter || empty()));
    return caseQueryBuilder.build();
  };

  private tracker = async () => {
    const { router } = this.props;
    const { transactionUpdate } = this.state;
    if (this.alarmDomainSubscription?.ready() && this.transactionSubscription?.ready() && this.ruleSubscription?.ready()) {
      const previousSearchParams = new URLSearchParams(router.params.id);
      const domainName = previousSearchParams.get('domain');
      const alarmDomainQuery: query.Query = query.QueryBuilder.select().from(CollectionNames.CASE_SETTINGS).where(eq('name', domainName)).build();
      const alarmDomainRaw: CaseSettings | undefined = await this.repository.find(alarmDomainQuery);
      const alarmDomain = alarmDomainRaw ? CaseActionUtil.normalizeCaseSettingsActions(alarmDomainRaw) as CaseSettings : undefined;
      if (this.state.selectedAdditionalCaseSettings == undefined) {
        this.setState({ selectedAdditionalCaseSettings: alarmDomain });
      }
      this.setState({ alarmDomain, loading: false, transactionUpdate: transactionUpdate + 1 }, () => {
        this.getFilterFields();
        if (!this.caseGoCompleted && alarmDomain != undefined) {
          const routeParams = new URLSearchParams(router.params.id);
          const goDomainName = routeParams.get('domain');
          const goCaseIndex = routeParams.get('index');
          const goTransactionName = routeParams.get('transaction');
          if (goDomainName && goCaseIndex && goTransactionName) {
            void this.tryCaseGo(goDomainName, goCaseIndex, goTransactionName, alarmDomain);
          }
        }
        if (this.state.currentTransaction) {
          this.checkActionButtonsDisabled(this.state.currentTransaction);
        }
      });
    }
  };

  private loadAssignableUsers = async (): Promise<void> => {
    const { router } = this.props;
    const domainName: string | null = new URLSearchParams(router.params.id).get('domain');
    if (domainName == null || domainName === '') {
      return;
    }
    try {
      const users: User[] = await this.caseService.getAssignableCaseUsers(domainName);
      this.setState({ users });
    } catch (e) {
      console.error(e);
      this.setState({ users: [] });
    }
  };

  private getRouteParams = () => {
    const { router } = this.props;
    const params = NavigationUtil.parseUrlParams(router.params.id);

    const domainName: string | null = params['domain'];
    const caseIndex: string | null = params['index'];
    const transaction: string | null = params['transaction'];
    const keyField: string | null = params['keyField'];
    const keyValue: string | null = params['keyValue'];

    return {
      domain: domainName,
      index: caseIndex,
      transaction,
      keyField,
      keyValue,
    };
  };

  private getGraphGroups = (): CaseGraphField[] => {
    const { alarmDomain } = this.state;
    const arr: CaseGraphField[] = [];
    alarmDomain?.graphConfiguration.forEach((f) => {
      if (f.enabled) {
        arr.push({ label: f.field, field: f.field, icon: f.color, dataType: f.dataType ?? DataType.STRING });
      }
    });
    return arr;
  };

  private escapeFilterKeyword = (filter: Filter) => {
    switch (filter.filterType) {
      case 'MatchFilter':
        const f = filter as MatchFilter<any>;
        f.key = f.key.replace(/.keyword/g, '');
        break;
      case 'ConditionalFilter':
        const c = filter as ConditionalFilter;
        c.filters.forEach((f) => this.escapeFilterKeyword(f));
        break;
    }
    return filter;
  };

  private tryCaseGo = async (
    domainName: string,
    caseIndex: string,
    transactionName: string,
    alarmDomain: CaseSettings | undefined,
  ): Promise<TransactionData | undefined> => {
    if (this.caseGoCompleted || this.caseGoInFlight) {
      return undefined;
    }
    if (!alarmDomain) {
      return undefined;
    }
    if (!canUseCaseGo(alarmDomain, 'Cases')) {
      this.caseGoCompleted = true;
      return undefined;
    }
    this.caseGoInFlight = true;
    try {
      const updatedCase: TransactionData = await this.caseService.goCase(domainName, caseIndex, transactionName);
      this.caseGoCompleted = true;
      if (updatedCase != undefined) {
        this.setState({ currentTransaction: updatedCase }, () => {
          this.subscribeToLogs(updatedCase);
          this.checkActionButtonsDisabled(updatedCase);
        });
      }
      return updatedCase;
    } catch (error) {
      console.error('Failed to assign case on open', error);
      this.caseGoCompleted = true;
      return undefined;
    } finally {
      this.caseGoInFlight = false;
    }
  };

  private fetchCase = async () => {
    const { router } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const domainName: string | null = previousSearchParams.get('domain');
    const caseIndex: string | null = previousSearchParams.get('index');
    const transaction: string | null = previousSearchParams.get('transaction');
    if (!domainName || !caseIndex || !transaction) {
      return;
    }
    const alarmDomainQuery: query.Query = query.QueryBuilder.select().from(CollectionNames.CASE_SETTINGS).where(eq('name', domainName)).build();
    const alarmDomainRaw: CaseSettings | undefined = await this.repository.find(alarmDomainQuery);
    let alarmDomain: CaseSettings | undefined = alarmDomainRaw
      ? (CaseActionUtil.normalizeCaseSettingsActions(alarmDomainRaw) as CaseSettings)
      : undefined;
    if (alarmDomain == undefined) {
      alarmDomain = await this.caseSettingsService.getByChannel(transaction);
    }
    if (alarmDomain != undefined) {
      this.setState({ alarmDomain });
    }
    await this.tryCaseGo(domainName, caseIndex, transaction, alarmDomain);
  };

  private checkActionButtonsDisabled = (transaction: TransactionData) => {
    const { user } = this.props;
    const { alarmDomain } = this.state;

    if (!alarmDomain || !transaction) return;

    const isAdmin = user.roles.includes('Admin') || user.role === 'Admin' || user.role === 'Root';
    if (isAdmin) {
      this.setState({ disabled: false });
      return;
    }

    let isDisabled = !canEditCaseDomain(alarmDomain, 'Cases');

    const result = transaction.result?.[user.activeRiskType];
    const currentAssignee = assigneeIdFromStoredValue(result?.metadata?.assignee?.id);
    if (currentAssignee !== undefined && currentAssignee !== 'System' && currentAssignee !== user.username) {
      isDisabled = true;
    }

    this.setState({ disabled: isDisabled });
  };

  private fetchCount = async () => {
    const { selectedAdditionalCaseSettings } = this.state;
    if (selectedAdditionalCaseSettings == undefined) return;
    const domain = selectedAdditionalCaseSettings.name;
    try {
      const _query = this.getCaseSubscriptionQuery();
      const fetchQuery = QueryBuilder.select()
        .from(_query.source)
        .where(_query.filter || empty())
        .build();
      const count = await this.caseService.getCaseCount(domain, fetchQuery);
      if (this.state.totalRecord == count) return;
      this.setState({ totalRecord: count });
    } catch (e) {}
  };

  private getChannelTabs = (): Array<{
    key: string;
    label: string | ReactNode;
    content?: ReactNode | any;
  }> => {
    const { alarmDomain } = this.state;
    if (alarmDomain == undefined) return [];
    const channels = [
      {
        key: alarmDomain.dataSource,
        label: alarmDomain.name,
      },
    ];
    alarmDomain.additionalChannels.map((channel) => {
      channels.push({
        key: channel.channel,
        label: channel.channel,
      });
    });
    return channels;
  };

  private onChangeChannel = async (e: any, tab: string) => {
    const { transactionUpdate } = this.state;
    this.setState({ transactionDataLoading: true, transactions: [] });

    const domain = tab === this.state.alarmDomain?.dataSource ? undefined : await this.caseSettingsService.getByChannel(tab);

    this.setState({ selectedAdditionalCaseSettings: domain, sort: [], transactionUpdate: transactionUpdate + 1 }, async () => {
      await this.getFilterFields(true);
      await this.handleAdditionalChannelFilter();
      this.restartTransactionInterval();
    });
  };

  private handleAdditionalChannelFilter = async (): Promise<void> => {
    const { selectedAdditionalCaseSettings, alarmDomain, currentTransaction } = this.state;
    if (alarmDomain == undefined) return;

    if (selectedAdditionalCaseSettings == undefined) {
      const params = this.getRouteParams();
      await this.addInitialFilter(params.keyField, params.keyValue);
      return;
    }

    if (selectedAdditionalCaseSettings.dataSource == currentTransaction?.name) {
      const params = this.getRouteParams();
      await this.addInitialFilter(params.keyField, params.keyValue);
      return;
    }
    const additionalChannel = alarmDomain.additionalChannels.find((c) => c.channel == selectedAdditionalCaseSettings.dataSource);
    if (additionalChannel == undefined) return;
    const keyField = additionalChannel.keyField ?? alarmDomain.keyField;
    const keyValue = currentTransaction?.variables[keyField];
    await this.addInitialFilter(additionalChannel.field, keyValue);
  };

  private getAdditionalOrDefaultTransaction = (): string | undefined | null => {
    return this.state.selectedAdditionalCaseSettings?.dataSource ?? this.state.alarmDomain?.dataSource ?? this.getRouteParams().transaction;
  };

  private actionModalOpen = () => {
    if (this.state.disabled) return;
    this.setState({ actionModalVisible: true });
  };

  private listModalOpen = () => {
    if (this.state.disabled) return;
    this.setState({ listModalVisible: true });
  };

  private goNextCase = async () => {
    const { router } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    try {
      const domainName: string | null = previousSearchParams.get('domain');
      if (domainName == null) return;
      const nextCase: TransactionData | undefined = (await this.caseService.nextCase(domainName))?._source;
      if (nextCase == undefined) {
        MessageUtil.info({
          summary: LanguageUtil.get({ id: 'messages.info.nextTransaction', defaultMessage: 'Next transaction' }),
          detail: LanguageUtil.get({ id: 'messages.info.noNext', defaultMessage: 'No next transaction to assign was found!' }),
        });
        return;
      }
      const caseSettings: CaseSettings | undefined = await this.repository.find(
        query.QueryBuilder.select().from(CollectionNames.CASE_SETTINGS).where(eq('dataSource', nextCase.name)).build(),
      );
      if (caseSettings == undefined) return;

      const urlSearchParams = new URLSearchParams();
      urlSearchParams.set('index', nextCase.id);
      urlSearchParams.set('domain', caseSettings.name);
      urlSearchParams.set('transaction', caseSettings.dataSource);
      urlSearchParams.set('keyField', caseSettings.keyField);
      urlSearchParams.set('keyValue', nextCase.variables[caseSettings.keyField]);
      urlSearchParams.forEach((value, key) => {
        urlSearchParams.set(key, value.replace(/ /g, '%20'));
      });
      const url = `/${NavigationUtil.getTenant()}/cases/${caseSettings.name}/detail/${urlSearchParams.toString()}`;
      window.open(url, '_blank');
    } catch (e) {}
  };

  private commentModalOpen = () => {
    this.setState({ commentModalVisible: true });
  };

  private commentModalClose = () => {
    this.setState({ commentModalVisible: false });
  };

  private getScores = async () => {
    const { alarmDomain, currentTransaction } = this.state;
    if (alarmDomain && currentTransaction) {
      const keyField: string = alarmDomain.keyField;
      const keyValue = currentTransaction.variables[keyField];
      if (keyValue == undefined) return;
      try {
        const scores = await this.caseService.getScores(alarmDomain.name, {
          key: keyField,
          keyValue,
        });
        this.setState({ scores });
      } catch (e) {
        console.error(e);
      }
    }
  };

  private exportTransactionData = () => {
    const {
      component: { selectedComponentIds },
    } = this.props;
    const { selectedAdditionalCaseSettings, alarmDomain } = this.state;
    const transactionSource = selectedAdditionalCaseSettings?.dataSource ?? alarmDomain?.dataSource;
    if (transactionSource == undefined) return;
    const query = this.getCaseSubscriptionQuery();
    if (selectedComponentIds.length > 0) {
      query.filter = and(
        eq('name.keyword', transactionSource),
        or(...selectedComponentIds.map((component: TransactionData) => eq('id.keyword', component.id))),
      );
    }
    
    const columns = this.getColumns();
    const selectedColumns = buildExportColumnPreferences(columns);

    const payload: TransactionDataExportJob = {
      type: 'CASE_DATA_EXPORT',
      transaction: transactionSource,
      query,
      timestamp: moment().valueOf(),
      status: 'PENDING',
      extension: 'csv',
      path: '',
      columnPreferences: selectedColumns,
    };
    this.jobService.schedule(payload);
    MessageUtil.success({
      summary: LanguageUtil.get({ id: 'common.label.export', defaultMessage: 'Export' }),
      detail: <div>{LanguageUtil.get({ id: 'messages.success.exportScheduled', defaultMessage: 'Export scheduled' })}</div>,
    });
  };

  private getFilterFields = async (saveFilter: boolean = true) => {
    const { alarmDomain, selectedAdditionalCaseSettings } = this.state;
    const dataSource = selectedAdditionalCaseSettings?.dataSource ?? alarmDomain?.dataSource;
    if (dataSource) {
      await FilterUtil.getCaseFields(dataSource, saveFilter);
    }
  };

  private addInitialFilter = (keyField: string | null, keyValue: any): Promise<void> => {
    return new Promise((resolve) => {
      const { changePageFilter } = this.props;
      const filter: {
        filter: FilterType;
        items: CustomFilterFields[];
      } = store.getState().page.filter;
      filter.filter.fields = [];
      if (keyField != undefined && keyValue != undefined) {
        filter.filter.fields.push({
          field: `variables.${keyField}.keyword`,
          label: keyField,
          enabled: true,
          search: {
            type: 'LITERAL',
            value: {
              properties: {
                dataType: DataType.STRING,
              },
              operator: 'eq',
              value: keyValue,
            } as CustomFilterLiteralSearch,
          },
        });
        this.setState({ filter: FilterUtil.parse(filter.filter) }, resolve);
        changePageFilter(filter);
      } else {
        resolve();
      }
    });
  };

  private onPageChange = (page: number, rows: number) => {
    this.setState({ rows, currentPage: page }, () => {
      this.restartTransactionInterval();
    });
  };

  private onSortChange = (sort: Order[]) => {
    this.setState({ sort }, this.restartTransactionInterval);
  };

  private onChangeFilter = (filter: Filter) => {
    this.setState({ filter }, this.restartTransactionInterval);
  };

  private isDisabled = () => {
    const { alarmDomain, currentTransaction } = this.state;
    const { user } = this.props;
    if (alarmDomain == undefined || currentTransaction == undefined) return;

    if (user.roles.includes('Admin') || user.role == 'Admin' || user.role == 'Root') {
      this.setState({ disabled: false });
      return;
    }

    let isDisabled = !canEditCaseDomain(alarmDomain, 'Cases');

    const currentAssignee = assigneeIdFromStoredValue(currentTransaction.result[user.activeRiskType].metadata?.assignee?.id);
    if (currentAssignee !== undefined && currentAssignee !== 'System' && currentAssignee !== user.username) {
      isDisabled = true;
    }
    this.setState({ disabled: isDisabled });
  };

  private getTransactionName = (): string => {
    const { router } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const transaction: string | null = previousSearchParams.get('transaction');
    return transaction || '';
  };

  private closeBulk = async (e: MouseEvent<HTMLButtonElement>, type: 'FRAUD' | 'NOT_FRAUD') => {
    const { alarmDomain, selectedAdditionalCaseSettings } = this.state;
    const {
      component: { selectedComponentIds },
      user,
    } = this.props;
    const selectedIds: CloseCaseBulkActionOperation[] = selectedComponentIds.map((component: TransactionData) => ({
      id: component.id,
      index: component._index,
    }));
    const domain = selectedAdditionalCaseSettings ?? alarmDomain;
    if (!domain) return;
    if (!canPerformBulkClose(user.username, domain, 'Cases')) {
      return;
    }
    customConfirm({
      target: e.currentTarget,
      rejectIcon: <Icon icon={'close'} className={'text-[#1873D5]'} size={20} />,
      acceptIcon: <Icon icon={'check'} className={'text-white'} size={20} />,
      rejectLabel: LanguageUtil.get({ id: 'common.label.cancel' }),
      acceptLabel: LanguageUtil.get({ id: 'common.label.okay' }),
      accept: async () => {
        const riskType = user.activeRiskType;
        const _type =
          type == 'FRAUD'
            ? riskType == 'fraud'
              ? TransactionReason.FRAUD
              : TransactionReason.IN_COMPLIANT
            : riskType == 'fraud'
              ? TransactionReason.NOT_FRAUD
              : TransactionReason.COMPLIANT;
        await this.caseService.closeBulkCase(user, domain.name, selectedIds, _type, this.state.reason, domain).then(() => {
          MessageUtil.success({
            summary: LanguageUtil.get({ id: `common.label.case`, defaultMessage: 'Case' }),
            detail: <div>{LanguageUtil.get({ id: `common.label.case`, defaultMessage: 'Case' })} closed</div>,
          });
        }).catch(() => {
          MessageUtil.error({
            summary: LanguageUtil.get({ id: `common.label.case`, defaultMessage: 'Case' }),
            detail: <div>{LanguageUtil.get({ id: 'messages.error.error', defaultMessage: 'Error.' })}</div>,
          });
        });
        this.setState({ reason: undefined });
      },
      reject: async () => {
        this.setState({ reason: undefined });
      },
      message: (
        <FormicaSearchSelectBox
          placeholder={LanguageUtil.get({ id: 'common.input.placeholder.reason', defaultMessage: 'Reason' })}
          options={this.prepareReasonSelectBox(type)}
          value={this.state.reason}
          className={'w-full'}
          onChange={(e: FormicaSelectBoxItem) => this.setState({ reason: e.value })}
        />
      ),
    });
  };

  private prepareReasonSelectBox = (type: string): any => {
    const { alarmDomain, selectedAdditionalCaseSettings } = this.state;
    const { user } = this.props;
    const riskType = user.activeRiskType;
    const _type = type == 'FRAUD' ? (riskType == 'fraud' ? 'FRAUD' : 'IN_COMPLIANT') : riskType == 'fraud' ? 'NOT_FRAUD' : 'COMPLIANT';
    const domain = selectedAdditionalCaseSettings ?? alarmDomain;
    return domain?.closeCodes
      .filter((r) => r.status == _type)
      .map((reason: AlarmCloseCode) => {
        return {
          label: reason.code,
          value: reason.code,
        };
      });
  };

  private getColumns = () => {
    const { selectedAdditionalCaseSettings, alarmDomain } = this.state;
    const key = selectedAdditionalCaseSettings?.dataSource ?? alarmDomain?.dataSource ?? 'default';
    return this.props.case.columns[key] ?? [];
  };

  private onChangeColumnPreferences = (selectedColumns: FormicaSelectBoxItem[]) => {
    const {
      changeCaseColumns,
      case: { columns },
      attributes,
      setAttribute,
    } = this.props;
    const { alarmDomain, selectedAdditionalCaseSettings, rows } = this.state;
    const hiddenColumns: string[] = [];
    for (const column of this.getColumns()) {
      column.hidden = selectedColumns.find((c) => c.value == column.field) == undefined;
      if (column.hidden) {
        hiddenColumns.push(column.field!);
      }
    }
    const tableId = selectedAdditionalCaseSettings?.dataSource ?? alarmDomain?.dataSource;
    let table: UserSystemTableAttributes | undefined = attributes.table.find((t) => t.component == ComponentName.CASE && t.id == tableId);
    if (table == undefined) {
      table = {
        id: tableId,
        component: ComponentName.CASE,
        columnOrder: [],
        hiddenColumns: [],
        pageSize: 0,
      };
      attributes.table.push(table);
    }
    table.hiddenColumns = hiddenColumns;
    table.pageSize = rows;
    setAttribute(attributes);
    changeCaseColumns(columns);
  };

  private getDetailContent = () => {
    const {
      loading,
      currentTransaction,
      transactions,
      alarmDomain,
      scores,
      activeRuleCount,
      totalRecord,
      rows,
      currentPage,
      selectedAdditionalCaseSettings,
      transactionUpdate,
    } = this.state;
    const { user } = this.props;

    const columns = this.getColumns();
    const bulkCloseDomain = selectedAdditionalCaseSettings ?? alarmDomain;

    if (currentTransaction == undefined || alarmDomain == undefined) {
      return <CustomLoading />;
    }

    return (
      <div className={'flex flex-col h-full w-full overflow-y-scroll p-5 gap-y-5 max-h-[calc(100vh-16rem)]'}>
        <div className={'grid grid-cols-1'}>
          <CaseDetailIndicatorPanelComponent
            scores={scores}
            transactionData={currentTransaction}
            alarmDomain={alarmDomain}
            activeRuleCount={activeRuleCount}
            riskType={user.activeRiskType}
          />
        </div>
        <div className={'grid  grid-cols-1 lg:grid-cols-2 gap-x-5 gap-y-5'}>
          <CaseDetailSummaryPanelComponent
            key={`summary-panel-${currentTransaction?.id}-${transactionUpdate}`}
            transactionData={currentTransaction}
            riskType={user.activeRiskType}
          />
          <CaseGraphComponent
            transaction={this.getTransactionName()}
            key={`graph-${currentTransaction?.id}`}
            domain={alarmDomain}
            groups={this.getGraphGroups()}
            transactionAmountField={alarmDomain.transactionAmountField}
            currencyConfiguration={alarmDomain.transactionCurrencyField}
            filter={this.state.filter}
            riskType={user.activeRiskType}
          />
        </div>
        <div className={'grid grid-cols-2 gap-y-5 gap-x-5 '}>
          {alarmDomain.panels
            ?.filter((p) => p.enabled)
            .map((panel, index) => {
              switch (panel.type) {
                case CasePanelType.CHART:
                  return <CaseDetailChartPanelComponent key={`${panel.title ?? ''}${index}-${transactionUpdate}`} transactionData={currentTransaction} panel={panel as CaseChartPanel}/>;
                default:
                  return (
                    <CaseDetailVariablePanelComponent
                      key={`${panel.title ?? ''}${index}-${transactionUpdate}`}
                      index={index}
                      panel={panel as CaseFieldPanel}
                      transactionData={currentTransaction}
                    />
                  );
              }
            })}
        </div>
        <div className={'grid grid-cols-1 gap-x-5 pb-0 2xl:pb-16'}>
          <ItemToolsMenu
            importVisible={false}
            componentLabel={`Transaction Activity ${ValueUtil.parseNumber(totalRecord)} transaction(s)`}
            exportFunc={this.exportTransactionData}
            exportVisibleAlways
            acceptFunc={(e) => this.closeBulk(e, 'NOT_FRAUD')}
            rejectFunc={(e) => this.closeBulk(e, 'FRAUD')}
            acceptVisible={canPerformBulkClose(user.username, bulkCloseDomain, 'Cases')}
            onChangeFilter={this.onChangeFilter}
            rejectVisible={canPerformBulkClose(user.username, bulkCloseDomain, 'Cases')}
            preferences={{
              columnPreferencesVisible: true,
              columns: columns.map((c) => ({ label: c.header, value: c.field })) as FormicaSelectBoxItem[],
              selectedColumns: columns
                .filter((c) => {
                  return !c.hidden;
                })
                .map((c) => ({ label: c.header, value: c.field })) as FormicaSelectBoxItem[],
              onChangeColumnPreferences: (selectedColumns: FormicaSelectBoxItem[]) => {
                this.onChangeColumnPreferences(selectedColumns);
              },
            }}
          />
          <div className={'pb-4'}>
            {alarmDomain.additionalChannels.length > 0 && (
              <div className='pb-4'>
                <CustomTabv3
                  tab={this.getChannelTabs()}
                  selectedTab={selectedAdditionalCaseSettings?.dataSource ?? alarmDomain?.dataSource}
                  onClick={this.onChangeChannel}
                />
              </div>
            )}
            <CaseTransactionsActivityComponent
              transactions={transactions}
              selectedAlarmDomain={selectedAdditionalCaseSettings ?? alarmDomain}
              total={totalRecord}
              rows={rows}
              update={transactionUpdate}
              paginationFixed={true}
              onPageChange={this.onPageChange}
              currentPage={currentPage}
              onSortChange={this.onSortChange}
              onChangeFilter={this.onChangeFilter}
              openInNewPage
              selectedTransactionId={currentTransaction.id}
              loading={loading || this.state.transactionDataLoading}
              multiple
              sort={this.state.sort}
              filterKey={selectedAdditionalCaseSettings?.dataSource ?? alarmDomain?.dataSource}
            />
          </div>
        </div>
      </div>
    );
  };

  protected getTabs = () => {
    const { currentTransaction } = this.state;
    return [
      {
        key: 'Information',
        label: LanguageUtil.get({ id: 'common.label.information', defaultMessage: 'Information' }),
        content: this.getDetailContent(),
      },
      {
        key: 'Audit Log',
        label: LanguageUtil.get({ id: 'common.label.audit', defaultMessage: 'Audit Log' }),
        content: <CaseAuditComponent transaction={currentTransaction} />,
      },
    ];
  };

  private subscribeToLogs = (currentTransaction: TransactionData) => {
    if (this.logSubscription != undefined) return;
    const logQuery = query.QueryBuilder.select()
      .where(
        or(
          and(neq('type', 'TAGGED_FIELD'), eq('transactionId', currentTransaction.id)),
          and(
            eq('type', 'TAGGED_FIELD'),
            neq('transactionId', currentTransaction.id),
            eq('channel', currentTransaction.name),
            or(
              ...Object.entries(currentTransaction.variables)
                .filter(([key, value]) => value == null || typeof value != 'object')
                .map(([key, value]) => {
                  return and(eq('taggedField', key), eq('taggedValue', value));
                }),
            ),
          ),
        ),
      )
      .limit(1000)
      .orderBy({
        field: 'timestamp',
        operator: 'DESC',
      })
      .build();
    this.logSubscription = subscribe.Formica.subscribe(`case_event_log_${NavigationUtil.getTenant()}_*`, logQuery, undefined, 'elasticsearch');
  };
}

interface Props extends FormicaProps, ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user as User,
  page: state.page as PageState,
  component: state.component as ComponentState,
  attributes: state.auth.attributes as UserSystemAttributes,
  case: state.case as CaseState,
});
const mapDispatchToProps = {
  enterComponent,
  leaveComponent,
  clearPage,
  changePageFilter,
  changeCaseColumns,
  setAttribute,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  currentTransaction: TransactionData | undefined;
  transactions: TransactionData[] = [];
  alarmDomain: CaseSettings | undefined;
  actionModalVisible: boolean = false;
  listModalVisible: boolean = false;
  commentModalVisible: boolean = false;
  loading = true;
  transactionDataLoading: boolean = true;
  totalRecord: number = 0;
  currentPage: number = 1;
  rows: number = 10;
  activeRuleCount: number = 0;
  scores: Record<string, number> = {};
  filter: Filter = empty();
  sort: Order[] = [];
  disabled: boolean = false;
  users: User[] = [];
  reason: string | undefined;
  selectedAdditionalCaseSettings: CaseSettings | undefined;
  transactionUpdate: number = 0;
  commentCount: number = 0;
  apiUpdateNoticeVisible: boolean = false;
  pendingApiTransaction: TransactionData | undefined;
}

export default withFormica(connector(CaseDetailComponent));
